/**
* @author mfranco (mfranco@mobinteg.com)
*/

import React, { Component } from "react"
import style from "./style.css"
import { connect } from "react-redux"
import Dropdown from "react-toolbox/lib/dropdown"
import AlertBox from "../../../components/CreatePaymentAgreementComponents/AlertBox"
import { Dialog } from "react-toolbox/lib/dialog"
import * as strings from "../../../strings"
import _ from "lodash"
import { getProcedureByContactId } from "../../../actions"

import CreatePaymentUserAgreement from "../CreatePaymentUserAgreement"

class CreatePaymentAgreement extends Component {

  props: {
    auth: any,
    debtorSearch: any,
    getProcedure: any,
    getProcedureByContactId: any,
    paymentAgreementState: any,
    onChange: any,
    debt: any,
    debtorId: any,
  }

  state = {
    alertBox: false,
    alertBoxMessage: undefined,
  }

  onChangeType = ( value ) => {
    const { debtDebtors } = this.props.debt
    const divStyle = { "padding-left": "20px" }
    let type = value
    let alertBox = this.state.alertBox
    let alertBoxMessage = undefined

    const mainDebtor = debtDebtors.find( debtDebtor => _.isEqual( debtDebtor.debtor.id, this.props.debt.idDebtor ) )
    const representant = debtDebtors.find( debtDebtor => debtDebtor.debtor.isRepresentant )

    if ( _.isEqual( value, "PaymentAgreement" ) || _.isEqual( value, "DebtRecognition" ) ) {
      if ( !( mainDebtor &&
        ( ( mainDebtor.debtor.isCollective && representant ) || !mainDebtor.debtor.isCollective ) ) ) {
        alertBox = true
        type = undefined
        alertBoxMessage = <div style={{ "padding-left": "50px" }}>
          <div>{strings.generalStrings.youHaveSomeFieldsMissing}</div>
          <div style={divStyle}>- {strings.generalStrings.mainDebtor}</div>
          <div style={divStyle}>- {strings.generalStrings.representantInCaseMainDebtorIsCollective}</div>
        </div>
      }
    } else {
      const guarantor = debtDebtors.find( debtDebtor => debtDebtor.debtor.isGuarantor )
      const guarantorRepresentant = debtDebtors.find( debtDebtor => debtDebtor.debtor.isGuarantorRepresentant )
      if ( !( mainDebtor && ( guarantor &&
        ( ( guarantor.debtor.isCollective && guarantorRepresentant ) || ( !guarantor.debtor.isCollective ) ) ) ) ) {
        alertBox = true
        type = undefined
        alertBoxMessage = <div style={{ "padding-left": "50px" }}>
          <div>{strings.generalStrings.youHaveSomeFieldsMissing}</div>
          <div style={divStyle}>- {strings.generalStrings.mainDebtor}</div>
          <div style={divStyle}>- {strings.generalStrings.guarantor}</div>
          <div style={divStyle}>- {strings.generalStrings.guarantorRepresentantInCaseGuarantorIsCollective}</div>
        </div>
      }
    }
    this.setState( {
      alertBox,
      alertBoxMessage,
    } )
    this.props.onChange( {
      type,
    } )
  }

  renderClientDropDown = () => {
    const { paymentAgreementState } = this.props

    const debtorsSource = _.get( this.props, "debt.debtDebtors", [] )
      .map( debtDebtor => ( {
        label: debtDebtor.debtor.contact.name,
        value: debtDebtor.idDebtor,
      } ) )

    const paymentAgreementTypeSource = [
      { label: strings.paymentAgreements.agreedPaymentAgreementTitle, value: "PaymentAgreement" },
      { label: strings.paymentAgreements.debtRecognition, value: "DebtRecognition" },
      { label: strings.paymentAgreements.debtRecognitionByThirdParty, value: "DebtRecognitionByThirdParty" },
    ]

    const isCollective = [
      { label: strings.paymentAgreements.singular, value: false },
      { label: strings.paymentAgreements.collective, value: true },
    ]

    const isRecognitionByThirdParty = paymentAgreementState.type === "DebtRecognitionByThirdParty"

    return (
      <div className={style.dropDownMenu}>
        <Dropdown
          label={strings.paymentAgreements.paymentAgreementType.toUpperCase()}
          auto
          onChange={ value => this.onChangeType( value )}
          source={paymentAgreementTypeSource}
          value={paymentAgreementState.type}
        />
        <Dropdown
          label={strings.debtor.title.toUpperCase()}
          auto
          disabled={!isRecognitionByThirdParty}
          onChange={ value => this.props.onChange( {
            debtorChecked: value,
          } )}
          source={debtorsSource}
          value={paymentAgreementState.debtorChecked}
        />
        <Dropdown
          label={strings.paymentAgreements.singularOrCollective.toUpperCase()}
          auto
          onChange={ value => this.props.onChange( {
            isCollective: value,
          } )}
          disabled={!isRecognitionByThirdParty}
          source={isCollective}
          value={paymentAgreementState.isCollective}
        />
      </div>
    )
  }

  handleAlertBox = () => {
    this.setState( {
      alertBox: !this.state.alertBox,
    } )
  }

  render () {
    return (
      <div className={style.createPaymentAgreementBackGround}>
        <div className={style.dropDown}>
          {this.renderClientDropDown()}
        </div>
        <div className={style.showContent}>
          <CreatePaymentUserAgreement
            onChange={this.props.onChange}
            paymentAgreementState={this.props.paymentAgreementState}
            searchValue={this.props.debt}
            hideBar
          />
        </div>
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: strings.generalStrings.ok, onClick: this.handleAlertBox },
          ]}
          onEscKeyDown={this.handleAlertBox}
          onOverlayClick={this.handleAlertBox}
          active={this.state.alertBox}>
          <AlertBox message={this.state.alertBoxMessage} />
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
    getProcedure: store.getProcedure,
  }
}

export default connect( mapStateToProps, { getProcedureByContactId } )( CreatePaymentAgreement )



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/CreatePaymentAgreement/index.jsx